import { useQuery } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import type { FieldDiaryEntryDTO } from './types';

interface UseGetFieldDiaryEntriesParams {
	propId?: string;
	forBinding?: string;
	month: string;
	enabled?: boolean;
}

export const useGetFieldDiaryEntries = ({
	propId,
	month,
	forBinding: ownerForBinding,
	enabled = true,
}: UseGetFieldDiaryEntriesParams) => {
	const contextForBinding = useForBindingId();
	const forBinding = ownerForBinding ?? contextForBinding;

	const query = useQuery({
		queryKey: ['fieldDiary', 'entries', forBinding, propId, month],
		enabled: enabled && !!propId,
		queryFn: async () => {
			const { data } = await api.get<{ data: { entries: FieldDiaryEntryDTO[] } }>(
				'/field-diary/entries/get',
				{ params: { forBinding, propId, month } }
			);
			return data.data.entries;
		},
	});

	return { ...query, data: query.data ?? [] };
};
